import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import AdministratorsModal from 'common/AdministratorsModal';

// AIDEV-NOTE: The "admins" button lives deep inside the disabled-state TCITooltip
// content; rendering AdministratorsModal next to that button means it unmounts the
// instant the tooltip closes (focus loss on dropdown close, etc.). This provider
// hoists the modal to the ManagePrograms level so its lifetime is independent of
// the tooltip subtree. `onOpen` lets the parent close the dropdown when a click
// inside the tooltip activates the button.
const Context = createContext(() => {});

export const useOpenContactAdminsModal = () => useContext(Context);

export const ContactAdminsModalProvider = ({ children, onOpen }) => {
  const [state, setState] = useState({ getAdminInfoPath: null, open: false });

  const open = (getAdminInfoPath) => {
    onOpen?.();
    setState({ getAdminInfoPath, open: true });
  };

  const close = () => setState({ getAdminInfoPath: null, open: false });

  return (
    <Context.Provider value={open}>
      {children}
      {state.open && (
        <AdministratorsModal
          isOpen
          closeModal={close}
          getAdminInfoPath={state.getAdminInfoPath}
        />
      )}
    </Context.Provider>
  );
};

ContactAdminsModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onOpen: PropTypes.func,
};

ContactAdminsModalProvider.defaultProps = {
  onOpen: undefined,
};
